// CP-278: package sailings say '7-night cruise' (the real cruise nights) next to a package label, instead of
// '7 nights', so the nights are not read as the whole package. When the package length is known from data, add
// ', part of a 10-night package'. Known = the leading 'N-night' of the server-derived package_label (CP-217: only the
// PO-ruled Celebrity Flora FL10 / FL11 codes map to a label: '10-night Quito + Galapagos package', '11-night ...').
// Nothing is inferred beyond that: no land / hotel night breakdown, no guess for a title that only says 'package'.
// Sailings with no package label and no 'package' in the title keep the plain nights label, unchanged.

// The existing Browse / Detail label: '1 night', '7 nights', '' for a missing or non-positive duration.
export function nightsLabel(n) {
  const num = Number(n);
  if (!Number.isFinite(num) || num <= 0) return '';
  const rounded = Math.round(num);
  return rounded === 1 ? '1 night' : `${rounded} nights`;
}

const PACKAGE_NIGHTS_RE = /^\s*(\d{1,2})-night\b/i;
const PACKAGE_WORD_RE = /\bpackages?\b/i;

// '10-night Quito + Galapagos package' -> 10. Anything else (null, '', a label without a leading N-night) -> null.
export function packageNightsFromLabel(label) {
  if (typeof label !== 'string') return null;
  const m = label.match(PACKAGE_NIGHTS_RE);
  if (!m) return null;
  const n = Number(m[1]);
  return n > 0 ? n : null;
}

// A sailing sold as a package: it shows a package label, or its title says 'package'.
export function isPackageSailing(sailing) {
  if (!sailing) return false;
  if (typeof sailing.package_label === 'string' && sailing.package_label.trim()) return true;
  return typeof sailing.name === 'string' && PACKAGE_WORD_RE.test(sailing.name);
}

// 'a 10-night', 'an 11-night', 'an 8-night', 'an 18-night' (spoken: eight, eleven, eighteen, eighty-...).
export function indefiniteArticle(n) {
  return /^(8\d*|11|18)$/.test(String(n)) ? 'an' : 'a';
}

// The nights text for the Browse card meta and the Detail chip.
//   non-package                           -> '7 nights'                               (unchanged)
//   package, length known and different   -> '7-night cruise, part of a 10-night package' (an 11-night ...)
//   package, length known and the same    -> '7 nights'                               (nothing to tell apart)
//   package, length not known             -> '7-night cruise'
// '11-night' must never break after the hyphen ('an 11-' / 'night package' at 390): the N-night tokens use a
// non-breaking hyphen (U+2011), which looks and reads like '-' but is not a line-break opportunity.
export const NB_HYPHEN = '\u2011';

export function sailingNightsLabel(sailing) {
  const plain = nightsLabel(sailing && sailing.duration);
  if (!plain || !isPackageSailing(sailing)) return plain;
  const nights = Math.round(Number(sailing.duration));
  const pkg = packageNightsFromLabel(sailing.package_label);
  if (pkg !== null && pkg === nights) return plain;
  const cruise = `${nights}${NB_HYPHEN}night cruise`;
  return pkg !== null ? `${cruise}, part of ${indefiniteArticle(pkg)} ${pkg}${NB_HYPHEN}night package` : cruise;
}
